/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Service,
  ServiceCreateRequest,
  ServicesDeleteDestroy200,
  ServicesMyServicesListParams
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Delete a service. Only the owner can delete their company's services.
 * @summary Delete service
 */
export const servicesDeleteDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<ServicesDeleteDestroy200>(
      {url: `/api/v1/services/${id}/delete/`, method: 'DELETE'
    },
      );
    }
  


export const getServicesDeleteDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesDeleteDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof servicesDeleteDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof servicesDeleteDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  servicesDeleteDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ServicesDeleteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof servicesDeleteDestroy>>>
    
    export type ServicesDeleteDestroyMutationError = void

    /**
 * @summary Delete service
 */
export const useServicesDeleteDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesDeleteDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof servicesDeleteDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getServicesDeleteDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific service by ID
 * @summary Get service by ID
 */
export const servicesDetailRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Service>(
      {url: `/api/v1/services/${id}/detail/`, method: 'GET', signal
    },
      );
    }
  

export const getServicesDetailRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/services/${id}/detail/`] as const;
    }

    
export const getServicesDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof servicesDetailRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof servicesDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServicesDetailRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof servicesDetailRetrieve>>> = ({ signal }) => servicesDetailRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof servicesDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ServicesDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof servicesDetailRetrieve>>>
export type ServicesDetailRetrieveQueryError = void

/**
 * @summary Get service by ID
 */
export const useServicesDetailRetrieve = <TData = Awaited<ReturnType<typeof servicesDetailRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof servicesDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getServicesDetailRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a service. Only the owner can update their company's services.
 * @summary Update service
 */
export const servicesUpdateUpdate = (
    id: number,
    serviceCreateRequest: ServiceCreateRequest,
 ) => {
      
      
      return customInstance<Service>(
      {url: `/api/v1/services/${id}/update/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceCreateRequest
    },
      );
    }
  


export const getServicesUpdateUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesUpdateUpdate>>, TError,{id: number;data: ServiceCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof servicesUpdateUpdate>>, TError,{id: number;data: ServiceCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof servicesUpdateUpdate>>, {id: number;data: ServiceCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  servicesUpdateUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ServicesUpdateUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof servicesUpdateUpdate>>>
    export type ServicesUpdateUpdateMutationBody = ServiceCreateRequest
    export type ServicesUpdateUpdateMutationError = void

    /**
 * @summary Update service
 */
export const useServicesUpdateUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesUpdateUpdate>>, TError,{id: number;data: ServiceCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof servicesUpdateUpdate>>,
        TError,
        {id: number;data: ServiceCreateRequest},
        TContext
      > => {

      const mutationOptions = getServicesUpdateUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a new service for the owner's company
 * @summary Create service
 */
export const servicesCreateCreate = (
    serviceCreateRequest: ServiceCreateRequest,
 ) => {
      
      
      return customInstance<Service>(
      {url: `/api/v1/services/create/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceCreateRequest
    },
      );
    }
  


export const getServicesCreateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesCreateCreate>>, TError,{data: ServiceCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof servicesCreateCreate>>, TError,{data: ServiceCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof servicesCreateCreate>>, {data: ServiceCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  servicesCreateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ServicesCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof servicesCreateCreate>>>
    export type ServicesCreateCreateMutationBody = ServiceCreateRequest
    export type ServicesCreateCreateMutationError = void

    /**
 * @summary Create service
 */
export const useServicesCreateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof servicesCreateCreate>>, TError,{data: ServiceCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof servicesCreateCreate>>,
        TError,
        {data: ServiceCreateRequest},
        TContext
      > => {

      const mutationOptions = getServicesCreateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get all services for the owner's company. Optional search on name and category. Paginated.
 * @summary Get my services
 */
export const servicesMyServicesList = (
    params?: ServicesMyServicesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Service[]>(
      {url: `/api/v1/services/myServices/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getServicesMyServicesListQueryKey = (params?: ServicesMyServicesListParams,) => {
    return [`/api/v1/services/myServices/`, ...(params ? [params]: [])] as const;
    }

    
export const getServicesMyServicesListQueryOptions = <TData = Awaited<ReturnType<typeof servicesMyServicesList>>, TError = unknown>(params?: ServicesMyServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof servicesMyServicesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServicesMyServicesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof servicesMyServicesList>>> = ({ signal }) => servicesMyServicesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof servicesMyServicesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ServicesMyServicesListQueryResult = NonNullable<Awaited<ReturnType<typeof servicesMyServicesList>>>
export type ServicesMyServicesListQueryError = unknown

/**
 * @summary Get my services
 */
export const useServicesMyServicesList = <TData = Awaited<ReturnType<typeof servicesMyServicesList>>, TError = unknown>(
 params?: ServicesMyServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof servicesMyServicesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getServicesMyServicesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



